export default __webpack_public_path__ + "static/media/box-plot.c5d7f8a2.svg";